import { render, staticRenderFns } from "./RefereeExamine.vue?vue&type=template&id=33821211&scoped=true&"
import script from "./RefereeExamine.vue?vue&type=script&lang=js&"
export * from "./RefereeExamine.vue?vue&type=script&lang=js&"
import style0 from "./RefereeExamine.vue?vue&type=style&index=0&id=33821211&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33821211",
  null
  
)

export default component.exports